__webpack_require__.p = "https://product-search.dev.core-artifacts.com/static/";